module.exports = __webpack_public_path__ + "static/media/9.af776f65.png";